module.exports = __webpack_public_path__ + "img/square-parking.728ecf1e.svg";